import React, { useState, useEffect, useRef } from "react";
import '../../../assets/styles/_hideOnScroll.scss';

const HideOnScroll = ({ children, direction = "up", hideAfter = 50 }) => {
  const [show, setShow] = useState(true);
  const lastScrollY = useRef(0);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY < hideAfter) {
      setShow(true);
    } else if (currentScrollY > lastScrollY.current) {
      setShow(false);
    } else {
      setShow(true);  
    }

    lastScrollY.current = currentScrollY;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`hide-on-scroll ${show ? "visible" : "hidden"} ${direction}`}>
      {children}
    </div>
  );
};

export default HideOnScroll;
